<template>
  <div>
    <a-card :bordered="false" class="ant-pro-components-tag-select">
      <a-form :form="form" layout="inline">
        <standard-form-row :title="$t('business.label.category')" block style="padding-bottom: 11px;">
          <a-form-item >
            <a-checkable-tag v-for="item in tags" :key="item.value" v-if="item.visible" v-model="item.selected" @change="handleChange">{{ item.name }}</a-checkable-tag>
          </a-form-item>
        </standard-form-row>

        <div class="ant-pro-pages-list-projects-cardList">
          <a-list :loading="loading" :data-source="recentMenus" :grid="{ gutter: 6, xl: 4, lg: 3, md: 3, sm: 2, xs: 1 }">
            <a-list-item slot="renderItem" slot-scope="item" @click="open(item)">
              <a-card class="ant-pro-pages-list-projects-card" hoverable>
                <a-card-meta :title="item.title" style="{text-align:center}">
                  <a-icon />
                </a-card-meta>
                <a-tag color="pink" style="{text-align:center;margin-top:5px;}">{{ item.timeFormat }}</a-tag>
<!--                <div class="cardItemContent">-->
<!--                  <div class="avatarList">-->
<!--                    <avatar-list size="large" maxLength="20">-->
<!--                      <avatar-list-item-->
<!--                        v-for="(member, i) in item.members"-->
<!--                        :key="`${item.no}-avatar-${i}`"-->
<!--                        :src="member.avatar"-->
<!--                        :tips="member.name"-->
<!--                      />-->
<!--                    </avatar-list>-->
<!--                  </div>-->
<!--                </div>-->
              </a-card>
            </a-list-item>
          </a-list>
        </div>
      </a-form>
    </a-card>
  </div>
</template>

<script>
  import { StandardFormRow,AvatarList } from '@/components'
  import IconText from './components/IconText'
  import Vue from 'vue'
  import store from '@/store'
  import { OPERATOR, RECENT_ROUTES } from '@/store/mutation-types'

  const AvatarListItem = AvatarList.AvatarItem

  export default {
    components: {
      StandardFormRow,
      IconText,
      AvatarList,
      AvatarListItem
    },
    data () {
      return {
        //owners,
        loading: true,
        loadingMore: false,
        data: [],
        recentMenus:[],
        tags: [
          { selected: false, value: 'dashboard', name: this.$t('menu.dashboard'), visible: false },
          { selected: false, value: 'basedata', name: this.$t('menu.baseData'), visible: false },
          { selected: false, value: 'inbound', name: this.$t('menu.inbound'), visible: false },
          { selected: false, value: 'outbound', name: this.$t('menu.outbound'), visible: false },
          { selected: false, value: 'warehouseManagement', name:this.$t('menu.warehouseManagement'), visible: false },
          { selected: false, value: 'qualityControl', name: this.$t('menu.qualityControl'), visible: false },
          { selected: false, value: 'authorityManage', name: this.$t('menu.authorityManage'), visible: false },
          { selected: false, value: 'config', name: this.$t('menu.configuration'), visible: false },
          { selected: false, value: 'query', name: this.$t('menu.query'), visible: false },
          { selected: false, value: 'other', name: this.$t('menu.others'), visible: false }
        ],
        form: this.$form.createForm(this),
      }
    },
    mounted () {
      this.getList()
    },
    methods: {
      handleChange () {
        this.getList()
      },
      getList () {
        this.loading=true
        this.recentMenus = Vue.ls.get(RECENT_ROUTES)===undefined?[]:Vue.ls.get(RECENT_ROUTES)
        this.recentMenus = this.recentMenus.filter(m=>m.title!==undefined&&m.path!==this.$route.path)
        this.tags.forEach(t=>{
          if(this.recentMenus.filter(r=>r.path.includes(t.value)).length>0){
            t.visible=true
          }
        })
        if(this.tags.filter(t=>t.selected).length>0){
          this.recentMenus = this.recentMenus.filter(m=>this.tags.filter(t=>t.selected&&m.path.includes(t.value)).length>0)
        }
        this.recentMenus = this.recentMenus.sort((a,b)=>{return b.time-a.time})
        this.loading=false
      },
      // loadMore () {
      //   this.loadingMore = true
      //   this.$http.get('/list/article').then(res => {
      //     this.data = this.data.concat(res.result)
      //   }).finally(() => {
      //     this.loadingMore = false
      //   })
      // },
      open(item){
        this.$router.push({ name: item.name }).catch(err => {})
      },
      search(text){
        if(text==='*'){
          this.getList()
        }else{
          this.recentMenus = this.recentMenus.filter(m=>m.title.includes(text)).sort((a,b)=>{return b.time-a.time })
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .ant-pro-components-tag-select {
    /deep/ .ant-pro-tag-select .ant-tag {
      margin-right: 24px;
      font-size: 14px;
    }
  }

  .list-articles-trigger {
    margin-left: 12px;
  }
</style>
